import { FlisPhraseRelation, NsnPhraseLink } from '@/api/generatedApi';
import { Box, TableBody, TableHead, TableRow, Typography } from '@mui/material';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from '../NsnTable';

export const PHRASE_RELATION_LABELS: Record<FlisPhraseRelation, string> = {
  [FlisPhraseRelation.ReplacedBy]: 'Replaced by',
  [FlisPhraseRelation.Replaces]: 'Replaces',
  [FlisPhraseRelation.InterchangeableWith]: 'Interchangeable with',
  [FlisPhraseRelation.SubstituteFor]: 'Substitute for',
  [FlisPhraseRelation.WhenExhaustedUse]: 'When exhausted, use',
  [FlisPhraseRelation.FabricateFrom]: 'Fabricate or assemble from',
};

export const PhraseLinksTable = ({ phraseLinks }: { phraseLinks: NsnPhraseLink[] }) => (
  <Box sx={{ marginBottom: '12px' }} data-testid='phrase-links'>
    <Typography variant='subtitle2'>Catalog links</Typography>
    <Typography variant='caption' color='text.secondary' component='div' sx={{ marginBottom: '4px' }}>
      Replacement, interchangeability, and fabrication links DLA records for this NSN in the FLIS phrase file.
    </Typography>
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell>Relationship</StyledHeaderCell>
          <StyledHeaderCell>NSN</StyledHeaderCell>
          <StyledHeaderCell>Item name</StyledHeaderCell>
          <StyledHeaderCell>Qty</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {phraseLinks.map(link => (
          <StyledTableRow key={`${link.relation}-${link.nsn}`}>
            <StyledTableCell>{PHRASE_RELATION_LABELS[link.relation]}</StyledTableCell>
            <StyledTableCell>{link.nsn}</StyledTableCell>
            <StyledTableCell>{link.itemName ?? 'Not in FLIS'}</StyledTableCell>
            <StyledTableCell>{link.quantity ?? ''}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  </Box>
);
